import axios from "axios";

export default axios.create({
    baseURL: "/api/",
    xsrfHeaderName: "X-CSRFToken",
    withCredentials: true
});
